import React, { useState } from 'react'

export default function Footer({ config, showToggleBtn = true }) {
  const [isShowFooter, setIsShowFooter] = useState(!showToggleBtn)
  const currentYear = new Date().getFullYear()

  return (
    <section className={`page-footer ${!showToggleBtn || isShowFooter ? 'show' : ''}`}>
      {showToggleBtn && (
        <button
          type="button"
          className={`btn-show-footer ${isShowFooter ? 'up' : ''}`}
          onClick={() => setIsShowFooter(prev => !prev)}
          aria-label="Toggle Footer"
        />
      )}
      {config.footerType === 'zh' ? (
        <section className="fifth-footer">
          <footer className="footer">
            <section className="footer-logo pc-show">
              <img
                loading="lazy"
                src="https://www.shengtiangames.com/statics/common/images/logo_h_w.png"
                alt="盛天网络"
              />
              <img src="./images/paras_logo.png" alt="paras" />
            </section>
            <section className="footer-beian">
              <main>
                <section className="beian-info">
                  <section className="friend-link">
                    <nav>
                      <a href="https://www.shengtian.com" title="盛天网络" target="_blank" rel="noopener noreferrer">盛天网络</a>|
                      <a href="https://www.tciplay.com" title="天戏互娱" target="_blank" rel="noopener noreferrer">天戏互娱</a>|
                      <a href="http://www.yilewan.com/" title="易乐玩" target="_blank" rel="noopener noreferrer">易乐玩</a>|
                      <a href="https://paras.shengtian.com/" title="Paras" target="_blank" rel="noopener noreferrer">Paras</a>|
                      <a href="https://yiqiyoo.com/" title="易起游" target="_blank" rel="noopener noreferrer">易起游</a>|
                      <a href="http://idoc.stnts.com/doc/info.html?id=60a2137e85f975031cbf3d9e" target="_blank" rel="noopener noreferrer" title="用户协议">用户协议</a>|
                      <a href="http://idoc.stnts.com/doc/info.html?id=60791358f2b722622ea91476" target="_blank" rel="noopener noreferrer" title="隐私协议">隐私协议</a>
                    </nav>

                    <section className="footer-tips pc-show">
                      <p> 健康游戏忠告：</p>
                      <p>抵制不良游戏，拒绝盗版游戏。注意自我保护，谨防受骗上当。</p>
                      <p>适度游戏益脑，沉迷游戏伤身。合理安排时间，享受健康生活。</p>
                    </section>
                    <section className="flex">
                      <p>©KOEI TECMO GAMES CO., LTD. All rights reserved.</p>
                      <p className="flex start mt-10">
                        <img
                          loading="lazy"
                          src="https://www.shengtiangames.com/statics/common/images/icon_beian.png"
                          alt=""
                        />
                        <a
                          style={{ marginLeft: '3px' }}
                          target="_blank"
                          rel="noopener noreferrer"
                          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=42018502002025"
                        >
                          <span>鄂公网安备 42018502002025号</span>
                        </a>
                      </p>
                    </section>
                  </section>
                </section>
                <section className="info">
                  <p>
                    ©湖北盛天网络技术股份有限公司版权所有：
                    <a
                      href="https://beian.miit.gov.cn/#/Integrated/index"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="武汉盛天游戏网络科技有限公司"
                    >
                      鄂B2-20110110
                    </a>
                  </p>
                  <p>运营商：武汉盛天游戏网络科技有限公司</p>
                  <p className="only-pid-PIDXcUDucHJT">公司地址：武汉东湖新技术开发区光谷大道77号</p>
                  <p>Copyright ©2006 - {currentYear} shengtian. All Rights Reserved</p>
                  <p>Copyright ©2021 - {currentYear} CENTURY GAME. All Rights Reserved</p>
                </section>
              </main>
            </section>
          </footer>
        </section>
      ) : (
        <section className="page-footer-container">
          <div className="flex footer-main" id="footer-main">
            <section className="flex-0 flex start jp-footer-left">
              <img
                loading="lazy"
                src={`${config.imgBase}game_logo.png`}
                alt=""
                className="flex-0 footer-game-icon"
              />
              <ul className="flex-0">
                <li>Category: Roguelite, Bullet Hell Shooter</li>
                <li>Compatible Models: PC </li>
              </ul>
            </section>
            <section className="flex flex-0 jp-footer-right">
              <img
                loading="lazy"
                src="https://www.shengtiangames.com/statics/common/images/logo_h_w.png"
                alt=""
                className="flex-0 st-logo"
              />
              <img
                loading="lazy"
                src="./images/paras_logo.png"
                height="60"
                alt=""
                className="flex-0 rt-logo"
              />
            </section>
          </div>
        </section>
      )}
    </section>
  )
}
